import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../theming/Titles.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Companion_getInstance3e8hrj2m27b5h as Companion_getInstance_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_compact3lsezez8nz8b6 as get_compact,
  dynamicThemexp3sdnaolntz as dynamicTheme,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  DisabledSemantic_getInstanceimdypc22j9b3 as DisabledSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atCenterStart2eaw4isrpvpjb as get_atCenterStart,
  get_centered1xfu6or5nc0lq as get_centered,
  forEachUpdating2xo34s2yjc7ia as forEachUpdating,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  get_scrollingHorizontally3ifk3kuuwhjjn as get_scrollingHorizontally,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  toList3jhuyej2anx2q as toList,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  get_rem14pbkv8p42gid as get_rem,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_dp28ag147e4p5cz as get_dp,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../theming/sections.mjs';
import { MenuButton27en4jjgdkozz as MenuButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/MenuButton.commonHtml.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import { ToggleButton22qnd3p3jsqqx as ToggleButton } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ToggleButton.commonHtml.mjs';
import { children3sl29z5no2wyp as children } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.ext.mjs';
import {
  withWritedlio9p0oewet as withWrite,
  modify2eca96i8s7hc2 as modify,
  invoke1ju2p3vzzanvk as invoke,
} from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtSetjrjc7fhfd6b9 as KtSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { debounce3uffs71hj1o26 as debounce } from '../../../../../reactive/com/lightningkite/reactive/extensions/debounce.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../../../../../reactive/com/lightningkite/reactive/core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function multiselect(_this__u8e3s4, query, pull, getId, hintText, toString, render, items, vertical, enabled, icon_0, setup) {
  hintText = hintText === VOID ? null : hintText;
  var tmp;
  if (render === VOID) {
    tmp = (_this__u8e3s4, item) => {
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextView())(_this__u8e3s4.pc());
      var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
      var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
      _this__u8e3s4.ebb(p, view);
      view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp = KMutableProperty0();
      var tmp_0 = TextView$_get_content_$ref_4pzcwl(view);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(view));
      reactiveScope(view, ($this$reactiveScope) => {
        var tmp0 = $this$reactiveScope.baj(item);
        // Inline function 'kotlin.let' call
        var tmp$ret$1 = toString(tmp0);
        this_0.set(tmp$ret$1);
        return Unit_instance;
      });
      _this__u8e3s4.fbb(p, view);
      return Unit_instance;
    };
  } else {
    tmp = render;
  }
  render = tmp;
  vertical = vertical === VOID ? true : vertical;
  var tmp_0;
  if (enabled === VOID) {
    tmp_0 = multiselect$lambda;
  } else {
    tmp_0 = enabled;
  }
  enabled = tmp_0;
  icon_0 = icon_0 === VOID ? Companion_getInstance().wcf_1 : icon_0;
  var tmp_1;
  if (setup === VOID) {
    tmp_1 = multiselect$lambda_0;
  } else {
    tmp_1 = setup;
  }
  setup = tmp_1;
  var tmp_2 = get_compact(_this__u8e3s4);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(false);
  dynamicTheme(view, ($this$dynamicTheme) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (enabled($this$dynamicTheme)) {
      tmp = null;
    } else {
      tmp = DisabledSemantic_getInstance();
    }
    return tmp;
  });
  if (vertical) {
    var tmp_3 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    var tmp_4 = get_atCenterStart(view_0);
    var tmp_5 = view_0.ibb(tmp_4, shownWhen(view_0, VOID, ($this$shownWhen) => $this$shownWhen.baj(items).i1()));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextView())(view_0.pc());
    var tmp0_elvis_lhs_1 = view_0.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
    view_0.ebb(p_1, view_1);
    view_1.jba(view_1.ob6_1.ybe(SmallBodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = hintText == null ? 'None selected' : hintText;
    var tmp_6 = view_1.tb5_1;
    var tmp_7;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_7 = '\xA0';
    } else {
      tmp_7 = value;
    }
    tmp_6.fbu(tmp_7);
    view_0.fbb(p_1, view_1);
    view_0.jbb(tmp_5, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_0.pc());
    var tmp0_elvis_lhs_2 = view_0.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
    view_0.ebb(p_2, view_2);
    view_2.xbm(true);
    view_2.zb8(get_rem(0.25));
    var tmp_8 = remember(VOID, VOID, VOID, ($this$remember) => toList($this$remember.baj(items)));
    forEachUpdating(view_2, tmp_8, VOID, ($this$forEachUpdating, item) => {
      var tmp = $this$forEachUpdating.ibb(get_compact($this$forEachUpdating), get_lightSection($this$forEachUpdating));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachUpdating.pc());
      var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
      $this$forEachUpdating.ebb(p, view);
      view.xbm(false);
      view.zb8(get_rem(0.25));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(view.pc(), 0.25);
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view.fbb(p_0, view_0);
      var tmp_0 = view.ibb(get_expanding(view), align(view, Align_Start_getInstance(), Align_Center_getInstance()));
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_1 = KMutableProperty0();
      var tmp_2 = TextView$_get_content_$ref_4pzcwl_0(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_0(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        var tmp0 = pull($this$reactiveScope, $this$reactiveScope.baj(item));
        // Inline function 'kotlin.let' call
        var tmp$ret$21 = toString(tmp0);
        this_0.set(tmp$ret$21);
        return Unit_instance;
      });
      view.fbb(p_1, view_1);
      view.jbb(tmp_0, view_1);
      var tmp_3 = align(view, Align_Center_getInstance(), Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      view_2.eba(get_rem(0.25));
      view_2.zb8(get_rem(0.25));
      icon(view_2, resize(Companion_getInstance().tcf_1, get_rem_0(1)), 'remove option');
      onClick(view_2, VOID, VOID, multiselect$lambda$slambda_0(items, item));
      view.fbb(p_2, view_2);
      view.jbb(tmp_3, view_2);
      $this$forEachUpdating.fbb(p, view);
      $this$forEachUpdating.jbb(tmp, view);
      return Unit_instance;
    });
    view_0.fbb(p_2, view_2);
    view.fbb(p_0, view_0);
    view.jbb(tmp_3, view_0);
  } else {
    var tmp_9 = get_expanding(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_3 = view.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
    view.ebb(p_3, view_3);
    var tmp_10 = get_atCenterStart(view_3);
    var tmp_11 = view_3.ibb(tmp_10, shownWhen(view_3, VOID, ($this$shownWhen) => $this$shownWhen.baj(items).i1()));
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_4 = new (TextView())(view_3.pc());
    var tmp0_elvis_lhs_4 = view_3.cbb_1;
    var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
    view_3.ebb(p_4, view_4);
    view_4.jba(view_4.ob6_1.ybe(SmallBodySemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value_0 = hintText == null ? 'None selected' : hintText;
    var tmp_12 = view_4.tb5_1;
    var tmp_13;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value_0) === 0) {
      tmp_13 = '\xA0';
    } else {
      tmp_13 = value_0;
    }
    tmp_12.fbu(tmp_13);
    view_3.fbb(p_4, view_4);
    view_3.jbb(tmp_11, view_4);
    var tmp_14 = get_scrollingHorizontally(view_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_5 = new (RowOrCol())(view_3.pc());
    var tmp0_elvis_lhs_5 = view_3.cbb_1;
    var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
    view_3.ebb(p_5, view_5);
    view_5.xbm(false);
    var tmp_15 = remember(VOID, VOID, VOID, ($this$remember) => toList($this$remember.baj(items)));
    forEachUpdating(view_5, tmp_15, VOID, ($this$forEachUpdating, item) => {
      var tmp = get_centered($this$forEachUpdating);
      // Inline function 'com.lightningkite.kiteui.views.card' call
      var tmp$ret$49 = $this$forEachUpdating.hbb(CardSemantic_getInstance());
      var tmp_0 = $this$forEachUpdating.ibb(tmp, tmp$ret$49);
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (RowOrCol())($this$forEachUpdating.pc());
      var tmp0_elvis_lhs = $this$forEachUpdating.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$forEachUpdating : tmp0_elvis_lhs;
      $this$forEachUpdating.ebb(p, view);
      view.xbm(false);
      view.zb8(get_rem(0.25));
      // Inline function 'com.lightningkite.kiteui.views.direct.space' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_0 = new (Space())(view.pc(), 0.25);
      var tmp0_elvis_lhs_0 = view.cbb_1;
      var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
      view.ebb(p_0, view_0);
      view.fbb(p_0, view_0);
      var tmp_1 = align(view, Align_Start_getInstance(), Align_Center_getInstance());
      // Inline function 'com.crowpay.views.theming.body' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (TextView())(view.pc());
      var tmp0_elvis_lhs_1 = view.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
      view.ebb(p_1, view_1);
      view_1.jba(view_1.ob6_1.ybe(BodySemantic_getInstance()));
      var tmp_2 = KMutableProperty0();
      var tmp_3 = TextView$_get_content_$ref_4pzcwl_1(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb_1(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
        var tmp0 = pull($this$reactiveScope, $this$reactiveScope.baj(item));
        // Inline function 'kotlin.let' call
        var tmp$ret$55 = toString(tmp0);
        this_0.set(tmp$ret$55);
        return Unit_instance;
      });
      view.fbb(p_1, view_1);
      view.jbb(tmp_1, view_1);
      var tmp_4 = align(view, Align_Center_getInstance(), Align_Center_getInstance());
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_2 = new (Button())(view.pc());
      var tmp0_elvis_lhs_2 = view.cbb_1;
      var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
      view.ebb(p_2, view_2);
      view_2.eba(get_rem(0.25));
      view_2.zb8(get_rem(0.25));
      icon(view_2, resize(Companion_getInstance().tcf_1, get_rem_0(1)), 'remove option');
      onClick(view_2, VOID, VOID, multiselect$lambda$slambda_2(items, item));
      view.fbb(p_2, view_2);
      view.jbb(tmp_4, view_2);
      $this$forEachUpdating.fbb(p, view);
      $this$forEachUpdating.jbb(tmp_0, view);
      return Unit_instance;
    });
    view_3.fbb(p_5, view_5);
    view_3.jbb(tmp_14, view_5);
    view.fbb(p_3, view_3);
    view.jbb(tmp_9, view_3);
  }
  var tmp_16 = view.ibb(get_compact(view), align(view, Align_Center_getInstance(), Align_Center_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.menuButton' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (MenuButton())(view.pc());
  var tmp0_elvis_lhs_6 = view.cbb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view : tmp0_elvis_lhs_6;
  view.ebb(p_6, view_6);
  view_6.bc4(Companion_getInstance_0().ycq_1);
  view_6.yc3_1 = true;
  var tmp_17 = KMutableProperty0();
  var tmp_18 = MenuButton$_get_shown_$ref_akusvw(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('shown', 0, tmp_17, tmp_18, MenuButton$_set_shown_$ref_ipznio(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$77 = enabled($this$reactiveScope);
    this_0.set(tmp$ret$77);
    return Unit_instance;
  });
  icon(view_6, resize(icon_0, get_rem(1.25)), 'Add item');
  view_6.ec4(($this$opensMenu) => {
    var search = Signal().fak('');
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$opensMenu.pc());
    var tmp0_elvis_lhs = $this$opensMenu.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$opensMenu : tmp0_elvis_lhs;
    $this$opensMenu.ebb(p, view);
    view.xbm(true);
    var tmp = get_centered(view);
    // Inline function 'com.crowpay.views.theming.subTitle' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.jba(view_0.ob6_1.ybe(SubtitleSemantic_getInstance()));
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp_0 = view_0.tb5_1;
    var tmp_1;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength('Select') === 0) {
      tmp_1 = '\xA0';
    } else {
      tmp_1 = 'Select';
    }
    tmp_0.fbu(tmp_1);
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp$ret$85 = view.hbb(FieldSemantic_getInstance());
    var tmp_2 = view.ibb(tmp$ret$85, get_compact(view));
    // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (TextInput())(view.pc());
    var tmp0_elvis_lhs_1 = view.cbb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.ebb(p_1, view_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
    // Inline function 'com.lightningkite.kiteui.views.placeholder' call
    view_1.tb5_1.zb3_1.ib7_1.placeholder = 'Search';
    view_1.xah(view_1.gcn_1, search);
    view_1.ob9();
    var tmp_3 = Companion_getInstance().vcf_1;
    view_1.mbg(Action('Select', tmp_3, VOID, VOID, VOID, VOID, multiselect$lambda$slambda_4(query, search, getId, items)));
    view.fbb(p_1, view_1);
    view.jbb(tmp_2, view_1);
    var tmp_4 = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem_0(17), get_rem_0(10));
    // Inline function 'com.lightningkite.kiteui.views.direct.recyclerView' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (Recycler2())(view, true);
    this_0.zb8(get_dp(5));
    var tmp_5 = rememberSuspending(VOID, VOID, VOID, multiselect$lambda$slambda_6(query, search));
    children(this_0, tmp_5, getId, ($this$children, item) => {
      var tmp = get_compact($this$children);
      // Inline function 'com.lightningkite.kiteui.views.direct.toggleButton' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (ToggleButton())($this$children.pc());
      var tmp0_elvis_lhs = $this$children.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$children : tmp0_elvis_lhs;
      $this$children.ebb(p, view);
      render(view, item);
      view.xah(view.ncq_1, containsDynamic(items, ($this$containsDynamic) => {
        var tmp0 = $this$containsDynamic.faj(item);
        // Inline function 'kotlin.let' call
        return getId(tmp0);
      }));
      $this$children.fbb(p, view);
      return $this$children.jbb(tmp, view);
    });
    view.jbb(tmp_4, this_0);
    $this$opensMenu.fbb(p, view);
    return Unit_instance;
  });
  view.fbb(p_6, view_6);
  view.jbb(tmp_16, view_6);
  setup(view);
  _this__u8e3s4.fbb(p, view);
  return _this__u8e3s4.jbb(tmp_2, view);
}
function containsDynamic(_this__u8e3s4, value) {
  var tmp = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.baj(_this__u8e3s4);
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = value($this$remember);
    return tmp.t1(tmp$ret$0);
  });
  return withWrite(tmp, containsDynamic$slambda_0(_this__u8e3s4, value));
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function multiselect$lambda(_this__u8e3s4) {
  return true;
}
function multiselect$lambda_0(_this__u8e3s4) {
  return Unit_instance;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = await_0($this.dga_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = await_0($this.ega_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.dga_1.gah(minus(tmp, tmp_0), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var multiselect$lambda$slambdaClass;
function multiselect$lambda$slambda() {
  if (multiselect$lambda$slambdaClass === VOID) {
    class $ {
      constructor($items, $item) {
        this.dga_1 = $items;
        this.ega_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    multiselect$lambda$slambdaClass = $;
  }
  return multiselect$lambda$slambdaClass;
}
function multiselect$lambda$slambda_0($items, $item) {
  var i = new (multiselect$lambda$slambda())($items, $item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = await_0($this.fga_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = await_0($this.gga_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = $this.fga_1.gah(minus(tmp, tmp_0), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
var multiselect$lambda$slambdaClass_0;
function multiselect$lambda$slambda_1() {
  if (multiselect$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($items, $item) {
        this.fga_1 = $items;
        this.gga_1 = $item;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    multiselect$lambda$slambdaClass_0 = $;
  }
  return multiselect$lambda$slambdaClass_0;
}
function multiselect$lambda$slambda_2($items, $item) {
  var i = new (multiselect$lambda$slambda_1())($items, $item);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function MenuButton$_get_shown_$ref_akusvw(p0) {
  return () => p0.wb8();
}
function MenuButton$_set_shown_$ref_ipznio(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_1($this, $this$Action, $completion) {
  var tmp = $this.hga_1($this.iga_1.f2(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = firstOrNull(tmp);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.let' call
    var id = $this.jga_1(tmp0_safe_receiver);
    var tmp_0 = modify($this.kga_1, multiselect$lambda$slambda$slambda_0(id), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var multiselect$lambda$slambda$slambdaClass;
function multiselect$lambda$slambda$slambda() {
  if (multiselect$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($id) {
        this.lga_1 = $id;
      }
      mga(it, $completion) {
        return it.t1(this.lga_1) ? minus(it, this.lga_1) : plus(it, this.lga_1);
      }
      s2(p1, $completion) {
        return this.mga((!(p1 == null) ? isInterface(p1, KtSet()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    multiselect$lambda$slambda$slambdaClass = $;
  }
  return multiselect$lambda$slambda$slambdaClass;
}
function multiselect$lambda$slambda$slambda_0($id) {
  var i = new (multiselect$lambda$slambda$slambda())($id);
  var l = (it, $completion) => i.mga(it, $completion);
  l.$arity = 1;
  return l;
}
var multiselect$lambda$slambdaClass_1;
function multiselect$lambda$slambda_3() {
  if (multiselect$lambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($query, $search, $getId, $items) {
        this.hga_1 = $query;
        this.iga_1 = $search;
        this.jga_1 = $getId;
        this.kga_1 = $items;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    multiselect$lambda$slambdaClass_1 = $;
  }
  return multiselect$lambda$slambdaClass_1;
}
function multiselect$lambda$slambda_4($query, $search, $getId, $items) {
  var i = new (multiselect$lambda$slambda_3())($query, $search, $getId, $items);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$rememberSuspending, $completion) {
  var tmp = await_0(debounce($this.oga_1, 500n), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.nga_1(tmp, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var multiselect$lambda$slambdaClass_2;
function multiselect$lambda$slambda_5() {
  if (multiselect$lambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($query, $search) {
        this.nga_1 = $query;
        this.oga_1 = $search;
      }
      wah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    multiselect$lambda$slambdaClass_2 = $;
  }
  return multiselect$lambda$slambdaClass_2;
}
function multiselect$lambda$slambda_6($query, $search) {
  var i = new (multiselect$lambda$slambda_5())($query, $search);
  var l = ($this$rememberSuspending, $completion) => i.wah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_3($this, $this$withWrite, on, $completion) {
  if (on) {
    var tmp = await_0($this.pga_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp_0 = invoke($this.qga_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = $this.pga_1.gah(plus(tmp, tmp_0), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  } else {
    var tmp_2 = await_0($this.pga_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = invoke($this.qga_1, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = $this.pga_1.gah(minus(tmp_2, tmp_3), $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
  }
  return Unit_instance;
}
var containsDynamic$slambdaClass;
function containsDynamic$slambda() {
  if (containsDynamic$slambdaClass === VOID) {
    class $ {
      constructor($this_containsDynamic, $value) {
        this.pga_1 = $this_containsDynamic;
        this.qga_1 = $value;
      }
      afz($this$withWrite, on, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, $this$withWrite, on), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Reactive()) : false) ? p1 : THROW_CCE();
        return this.afz(tmp, (!(p2 == null) ? typeof p2 === 'boolean' : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    containsDynamic$slambdaClass = $;
  }
  return containsDynamic$slambdaClass;
}
function containsDynamic$slambda_0($this_containsDynamic, $value) {
  var i = new (containsDynamic$slambda())($this_containsDynamic, $value);
  var l = ($this$withWrite, on, $completion) => i.afz($this$withWrite, on, $completion);
  l.$arity = 2;
  return l;
}
//region block: exports
export {
  containsDynamic as containsDynamic2l3li0bgncl7n,
  multiselect as multiselectp8aawqh86psn,
};
//endregion

//# sourceMappingURL=Multiselect.mjs.map
